var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitchButtonSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.27977C12.97295 1.27487 16.79912 4.2588 16.79912 9c0 4.7412-3.93149 8.01677-8.18324 7.71614C4.36413 16.4155 1.1661 12.93962 1.1661 9.0075",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/switch-button-spinner.svg";
export { SvgSwitchButtonSpinner as ReactComponent };